// Endpoint of the API Gateway route backed by the mailing-list Lambda.
// REACT_APP_MAILINGLIST_API_URL overrides it at build time if set.
const MAILING_LIST_API_URL =
  process.env.REACT_APP_MAILINGLIST_API_URL ||
  "https://4g40bu3v1i.execute-api.us-east-1.amazonaws.com/mailinglist";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function validateMailingListEntry({ company, name, email, hasConsent }) {
  const errors = {};

  if (!company.trim()) errors.company = "Bitte geben Sie Ihren Firmennamen ein.";
  if (!name.trim()) errors.name = "Bitte geben Sie Ihren Namen ein.";
  if (!email.trim()) {
    errors.email = "Bitte geben Sie Ihre E-Mail-Adresse ein.";
  } else if (!EMAIL_PATTERN.test(email.trim())) {
    errors.email = "Bitte geben Sie eine gültige E-Mail-Adresse ein.";
  }
  if (!hasConsent) errors.consent = "Bitte bestätigen Sie Ihre Einwilligung.";

  return errors;
}

export async function subscribeToMailingList({ company, name, email }) {
  const res = await fetch(MAILING_LIST_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      company: company.trim(),
      name: name.trim(),
      email: email.trim().toLowerCase(),
    }),
  });

  if (!res.ok) {
    throw new Error(`Mailing list signup failed with status ${res.status}`);
  }
}
